import { render, staticRenderFns } from "./TableInventory.vue?vue&type=template&id=65486b76"
import script from "./TableInventory.vue?vue&type=script&lang=js"
export * from "./TableInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports